import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  COLLAPSE_BUTTON: `${cleanedFilename(__filename)}-collapse-button`,
  CHILD_CONTAINER: `${cleanedFilename(__filename)}-child-container`,
};
